module.exports = __webpack_public_path__ + "static/media/mobile-bg.c122d997.jpg";